import React, { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import MailSidebar from '../MailInbox/MailSidebar';
import MailContain from './ReadMailContain';

const ReadMailContain = () => {
  return (
    <Fragment>
      <Container fluid={true}>
        <Breadcrumbs pageTitle='Email Application' parent='Email' title='Read Email' />
        <div className='email-wrap'>
          <Row>
            <Col xl='3' md='6' className='xl-30 box-col-30'>
              <MailSidebar />
            </Col>
            <Col xl='9' md='12' className='xl-70 box-col-70'>
              <MailContain />
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};
export default ReadMailContain;
